import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../shared/Header";
import Sidebar from "../shared/Sidebar";
import { getProfile } from "../core/services/profileService";

const MOBILE_BREAKPOINT = 1024;

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(
    () => window.innerWidth >= MOBILE_BREAKPOINT,
  );
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth < MOBILE_BREAKPOINT,
  );

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  useEffect(() => {
    const syncProfile = async () => {
      try {
        const result = await getProfile();
        if (result.success && result.admin) {
          localStorage.setItem("adminProfile", JSON.stringify(result.admin));
          window.dispatchEvent(new Event("adminProfile:updated"));
        }
      } catch {
        // Keep the stored profile if a refresh fails; route guards still apply.
      }
    };

    void syncProfile();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(mobile);

      if (mobile) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile && sidebarOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }

    document.body.style.overflow = "";
    return undefined;
  }, [isMobile, sidebarOpen]);

  return (
    <div
      className={`admin-shell ${sidebarOpen ? "sidebar-expanded" : "sidebar-collapsed"} ${isMobile && sidebarOpen ? "sidebar-mobile-open" : ""}`}
    >
      <Header onMenuClick={toggleSidebar} />

      <div className="admin-body">
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        <main className="admin-main">
          <div className="page-section page-stack">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
